<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-layout>
        <v-flex xs8 ma-2>Lizenz.xml oder VorlaeufigeLizenz.xml hochladen</v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-file-input
        :rules="inputRules"
        accept="text/xml"
        placeholder="Lizenz.xml oder VorlaeufigeLizenz.xml auswählen"
        v-model="file"
        small-chips
        show-size
        clearable
      ></v-file-input>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="upload" :disabled="disableUploadButton">Lizenz.xml oder VorlaeufigeLizenz.xml hochladen</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      file: null,
      inputRules: [
        v =>
          !v ||
          v.size < 10000000 ||
          "Die Lizenz.xml oder VorlaeufigeLizenz.xml darf nicht größer als 10 MB sein!"
      ]
    };
  },
  computed: {
    disableUploadButton: function() {
      return this.file == null;
    }
  },
  methods: {
    upload: function() {
      const fileReader = new FileReader();
      fileReader.readAsText(this.file);
      fileReader.onload = event => {
        this.$store.commit("startLoading");
        this.$socket.sendObj({
          eventID:
            "de.t2med.lizenzomat.eventapi.usecase.activiti.LizenzUploadRequestEvent",
          processId: this.$route.params.process,
          taskId: this.$route.params.task,
          lizenz: event.target.result
        });
      };
    }
  }
};
</script>
